<script lang="ts">
	interface Props {
		height?: string; // Default height
		width?: string; // Default width
		class?: string;
	}

	let { height = '513px', width = '2252px', class: className = '' }: Props = $props();
	
</script>

<svg
	viewBox="0 0 2252 513"
	fill="none"
	xmlns="http://www.w3.org/2000/svg"
	{height}
	{width}
	class={className}
>
	<g clip-path="url(#clip0_2227_994)">
		<path
			d="M511.908 48.1042C447.781 -16.0393 343.799 -16.0393 279.672 48.1042C215.546 -16.0393 111.563 -16.0393 47.4369 48.1042C25.1806 70.3792 10.6595 97.4403 3.86072 125.977C-5.14443 165.433 -5.61906 250.645 85.3689 289.819C111.409 299.686 142.709 301.714 178.05 289.139C191.327 284.007 204.001 276.834 215.584 267.608C216.598 266.8 217.598 265.966 218.586 265.119C219.715 264.182 220.857 263.22 221.96 262.219C222.165 262.052 222.345 261.86 222.576 261.68C224.384 260.038 226.206 258.319 227.963 256.561C230.285 254.238 232.504 251.839 234.647 249.401L161.233 218.465L161.271 218.426C162.336 217.361 179.513 200.488 191.25 201.643L257.621 213.627L269.256 215.732L291.949 193.02C292.334 192.635 336.551 148.47 356.011 159.569C367.107 179.034 322.954 223.264 322.569 223.649L299.863 246.36L301.967 257.985L313.948 324.374C315.103 336.102 298.234 353.283 297.17 354.36L297.131 354.399L266.203 280.979C263.766 283.108 261.38 285.341 259.045 287.664C257.288 289.421 255.582 291.244 253.927 293.053C253.747 293.271 253.555 293.463 253.388 293.669C252.388 294.772 251.413 295.901 250.489 297.043C249.642 298.031 248.809 299.032 248 300.046C203.167 356.439 206.541 438.559 258.058 491.129L279.647 512.724L511.882 280.427C576.034 216.258 576.034 112.26 511.908 48.1042Z"
			fill="url(#paint0_linear_2227_994)"
		/>
		<g style="mix-blend-mode:multiply">
			<path
				d="M431.593 360.738L279.673 512.711L258.083 491.116C206.567 438.559 203.193 356.426 248.026 300.033C248.834 299.019 249.668 298.018 250.515 297.03C251.451 295.888 252.413 294.759 253.414 293.656C253.581 293.45 253.773 293.271 253.953 293.04C255.595 291.231 257.301 289.409 259.071 287.651C261.393 285.328 263.792 283.108 266.229 280.966L297.157 354.386L297.195 354.348C298.26 353.283 315.129 336.102 313.974 324.361L301.993 257.972L299.889 246.347L322.595 223.636C322.979 223.251 367.133 179.021 356.037 159.556C351.893 157.195 346.621 157.349 340.9 159.043C391.16 139.411 441.522 157.067 465.856 193.906C493.782 236.223 488.677 303.369 431.593 360.738Z"
				fill="url(#paint1_linear_2227_994)"
			/>
		</g>
		<g style="mix-blend-mode:multiply">
			<path
				d="M431.593 360.738L279.673 512.711L258.083 491.116C206.567 438.559 203.193 356.426 248.026 300.033C248.834 299.019 249.668 298.018 250.515 297.03C251.451 295.888 252.413 294.759 253.414 293.656C253.581 293.45 253.773 293.271 253.953 293.04C255.595 291.231 257.301 289.409 259.071 287.651C261.393 285.328 263.792 283.108 266.229 280.966L297.157 354.386L297.195 354.348C298.26 353.283 315.129 336.102 313.974 324.361L301.993 257.972L299.889 246.347L322.595 223.636C322.979 223.251 367.133 179.021 356.037 159.556C351.893 157.195 346.621 157.349 340.9 159.043C391.16 139.411 441.522 157.067 465.856 193.906C493.782 236.223 488.677 303.369 431.593 360.738Z"
				fill="url(#paint2_linear_2227_994)"
			/>
		</g>
		<g style="mix-blend-mode:multiply">
			<path
				d="M431.593 360.738L279.673 512.711L258.083 491.116C206.567 438.559 203.193 356.426 248.026 300.033C248.834 299.019 249.668 298.018 250.515 297.03C251.451 295.888 252.413 294.759 253.414 293.656C253.581 293.45 253.773 293.271 253.953 293.04C255.595 291.231 257.301 289.409 259.071 287.651C261.393 285.328 263.792 283.108 266.229 280.966L297.157 354.386L297.195 354.348C298.26 353.283 315.129 336.102 313.974 324.361L301.993 257.972L299.889 246.347L322.595 223.636C322.979 223.251 367.133 179.021 356.037 159.556C351.893 157.195 346.621 157.349 340.9 159.043C391.16 139.411 441.522 157.067 465.856 193.906C493.782 236.223 488.677 303.369 431.593 360.738Z"
				fill="url(#paint3_linear_2227_994)"
			/>
		</g>
		<g style="mix-blend-mode:multiply">
			<path
				d="M431.593 360.738L279.673 512.711L258.083 491.116C206.567 438.559 203.193 356.426 248.026 300.033C248.834 299.019 249.668 298.018 250.515 297.03C251.451 295.888 252.413 294.759 253.414 293.656C253.581 293.45 253.773 293.271 253.953 293.04C255.595 291.231 257.301 289.409 259.071 287.651C261.393 285.328 263.792 283.108 266.229 280.966L297.157 354.386L297.195 354.348C298.26 353.283 315.129 336.102 313.974 324.361L301.993 257.972L299.889 246.347L322.595 223.636C322.979 223.251 367.133 179.021 356.037 159.556C351.893 157.195 346.621 157.349 340.9 159.043C391.159 139.411 441.522 157.067 465.856 193.906C493.782 236.223 488.677 303.369 431.593 360.738Z"
				fill="url(#paint4_linear_2227_994)"
			/>
		</g>
		<g style="mix-blend-mode:multiply">
			<path
				d="M337.423 206.878C349.224 192.16 362.719 171.348 356.01 159.569C351.867 157.208 346.595 157.362 340.874 159.056C391.133 139.424 441.495 157.08 465.83 193.918C474.809 207.519 480.364 223.7 481.877 241.291C474.655 178.996 383.834 155.194 337.423 206.878Z"
				fill="url(#paint5_linear_2227_994)"
			/>
		</g>
		<g style="mix-blend-mode:multiply">
			<path
				d="M337.423 206.878C349.224 192.16 362.719 171.348 356.01 159.569C351.867 157.208 346.595 157.362 340.874 159.056C391.133 139.424 441.495 157.08 465.83 193.918C474.809 207.519 480.364 223.7 481.877 241.291C474.655 178.996 383.834 155.194 337.423 206.878Z"
				fill="url(#paint6_linear_2227_994)"
			/>
		</g>
		<g style="mix-blend-mode:multiply">
			<path
				d="M337.423 206.878C349.224 192.16 362.719 171.348 356.01 159.569C351.867 157.208 346.595 157.362 340.874 159.056C391.133 139.424 441.495 157.08 465.83 193.918C474.809 207.519 480.364 223.7 481.877 241.291C474.655 178.996 383.834 155.194 337.423 206.878Z"
				fill="url(#paint7_linear_2227_994)"
			/>
		</g>
		<g style="mix-blend-mode:multiply">
			<path
				d="M279.673 512.711L258.083 491.116C206.567 438.559 203.193 356.426 248.026 300.033C248.834 299.019 249.668 298.019 250.515 297.031C251.451 295.889 252.413 294.759 253.414 293.656C253.581 293.451 253.773 293.271 253.953 293.04C255.595 291.231 257.301 289.409 259.071 287.651C261.393 285.328 263.792 283.109 266.229 280.966L297.157 354.386L297.195 354.348C298.26 353.283 315.129 336.102 313.974 324.361L313.346 320.871C315.539 330.879 335.692 422.687 279.673 512.711Z"
				fill="url(#paint8_linear_2227_994)"
			/>
		</g>
		<g style="mix-blend-mode:multiply">
			<path
				d="M279.673 512.711L258.083 491.116C206.567 438.559 203.193 356.426 248.026 300.033C248.834 299.019 249.668 298.019 250.515 297.031C251.451 295.889 252.413 294.759 253.414 293.656C253.581 293.451 253.773 293.271 253.953 293.04C255.595 291.231 257.301 289.409 259.071 287.651C261.393 285.328 263.792 283.109 266.229 280.966L297.157 354.386L297.195 354.348C298.26 353.283 315.129 336.102 313.974 324.361L313.346 320.871C315.539 330.879 335.692 422.687 279.673 512.711Z"
				fill="url(#paint9_linear_2227_994)"
			/>
		</g>
		<g style="mix-blend-mode:multiply">
			<path
				d="M279.673 512.711L258.083 491.116C206.567 438.559 203.193 356.426 248.026 300.033C248.834 299.019 249.668 298.019 250.515 297.031C251.451 295.889 252.413 294.759 253.414 293.656C253.581 293.451 253.773 293.271 253.953 293.04C255.595 291.231 257.301 289.409 259.071 287.651C261.393 285.328 263.792 283.109 266.229 280.966L297.157 354.386L297.195 354.348C298.26 353.283 315.129 336.102 313.974 324.361L313.346 320.871C315.539 330.879 335.692 422.687 279.673 512.711Z"
				fill="url(#paint10_linear_2227_994)"
			/>
		</g>
		<g style="mix-blend-mode:multiply">
			<path
				d="M279.673 512.711L258.083 491.116C206.567 438.559 203.193 356.426 248.026 300.033C248.834 299.019 249.668 298.019 250.515 297.031C251.451 295.889 252.413 294.759 253.414 293.656C253.581 293.451 253.773 293.271 253.953 293.04C255.595 291.231 257.301 289.409 259.071 287.651C261.393 285.328 263.792 283.109 266.229 280.966L297.157 354.386L297.195 354.348C298.26 353.283 315.129 336.102 313.974 324.361L313.346 320.871C315.539 330.879 335.692 422.687 279.673 512.711Z"
				fill="url(#paint11_linear_2227_994)"
			/>
		</g>
		<g style="mix-blend-mode:multiply">
			<path
				d="M279.672 512.711C324.852 437.725 297.182 354.361 297.182 354.361C298.247 353.296 315.115 336.114 313.961 324.374L313.332 320.884C315.539 330.879 335.691 422.687 279.672 512.711Z"
				fill="url(#paint12_linear_2227_994)"
			/>
		</g>
		<g style="mix-blend-mode:multiply">
			<path
				d="M279.672 512.711C324.852 437.725 297.182 354.361 297.182 354.361C298.247 353.296 315.115 336.114 313.961 324.374L313.332 320.884C315.539 330.879 335.691 422.687 279.672 512.711Z"
				fill="url(#paint13_linear_2227_994)"
			/>
		</g>
		<g style="mix-blend-mode:multiply">
			<path
				d="M178.063 289.126C142.709 301.701 111.409 299.673 85.3816 289.806C-5.61925 250.632 -5.14461 165.42 3.86054 125.977C10.6593 97.4401 25.1676 70.3789 47.4368 48.1167C88.2935 7.24918 145.3 -7.54525 197.895 3.65643C152.741 -3.52907 115.527 19.8623 100.416 53.9806C76.8767 107.128 104.777 185.552 208.657 204.786L191.263 201.643C179.538 200.488 162.362 217.361 161.284 218.426L161.245 218.464L234.659 249.401C232.53 251.838 230.298 254.238 227.976 256.56C226.206 258.318 224.397 260.038 222.588 261.68C222.357 261.86 222.178 262.052 221.973 262.219C220.869 263.22 219.741 264.182 218.599 265.119C217.611 265.966 216.611 266.8 215.597 267.608C204.014 276.821 191.34 283.994 178.063 289.126Z"
				fill="url(#paint14_linear_2227_994)"
			/>
		</g>
		<g style="mix-blend-mode:multiply">
			<path
				d="M178.063 289.126C142.709 301.701 111.409 299.673 85.3816 289.806C-5.61925 250.632 -5.14461 165.42 3.86054 125.977C10.6593 97.4401 25.1676 70.3789 47.4368 48.1167C88.2935 7.24918 145.3 -7.54525 197.895 3.65643C152.741 -3.52907 115.527 19.8623 100.416 53.9806C76.8767 107.128 104.777 185.552 208.657 204.786L191.263 201.643C179.538 200.488 162.362 217.361 161.284 218.426L161.245 218.464L234.659 249.401C232.53 251.838 230.298 254.238 227.976 256.56C226.206 258.318 224.397 260.038 222.588 261.68C222.357 261.86 222.178 262.052 221.973 262.219C220.869 263.22 219.741 264.182 218.599 265.119C217.611 265.966 216.611 266.8 215.597 267.608C204.014 276.821 191.34 283.994 178.063 289.126Z"
				fill="url(#paint15_linear_2227_994)"
			/>
		</g>
		<g style="mix-blend-mode:multiply">
			<path
				d="M178.063 289.126C142.709 301.701 111.409 299.673 85.3816 289.806C-5.61925 250.632 -5.14461 165.42 3.86054 125.977C10.6593 97.4401 25.1676 70.3789 47.4368 48.1167C88.2935 7.24918 145.3 -7.54525 197.895 3.65643C152.741 -3.52907 115.527 19.8623 100.416 53.9806C76.8767 107.128 104.777 185.552 208.657 204.786L191.263 201.643C179.538 200.488 162.362 217.361 161.284 218.426L161.245 218.464L234.659 249.401C232.53 251.839 230.298 254.238 227.976 256.56C226.206 258.318 224.397 260.038 222.588 261.68C222.357 261.86 222.178 262.052 221.973 262.219C220.869 263.22 219.741 264.182 218.599 265.119C217.611 265.966 216.611 266.8 215.597 267.608C204.014 276.821 191.34 283.994 178.063 289.126Z"
				fill="url(#paint16_linear_2227_994)"
			/>
		</g>
		<g style="mix-blend-mode:multiply">
			<path
				d="M96.5162 64.5796C80.815 117.021 111.499 186.797 208.657 204.787L191.263 201.643C179.538 200.488 162.362 217.361 161.284 218.426C109.678 196.126 68.6157 128.98 96.5162 64.5796Z"
				fill="url(#paint17_linear_2227_994)"
			/>
		</g>
		<g style="mix-blend-mode:multiply">
			<path
				d="M96.5162 64.5796C80.815 117.021 111.499 186.797 208.657 204.787L191.263 201.643C179.538 200.488 162.362 217.361 161.284 218.426C109.678 196.126 68.6157 128.98 96.5162 64.5796Z"
				fill="url(#paint18_linear_2227_994)"
			/>
		</g>
		<g style="mix-blend-mode:multiply">
			<path
				d="M96.5162 64.5796C80.815 117.021 111.499 186.797 208.657 204.787L191.263 201.643C179.538 200.488 162.362 217.361 161.284 218.426C109.678 196.126 68.6157 128.98 96.5162 64.5796Z"
				fill="url(#paint19_linear_2227_994)"
			/>
		</g>
	</g>
	<path
		d="M758.438 195.43C774.566 195.43 788.426 199.084 800.018 206.392C811.61 213.7 820.178 223.654 825.722 236.254V198.076H889.982V409H825.722V370.822C820.178 383.422 811.61 393.376 800.018 400.684C788.426 407.992 774.566 411.646 758.438 411.646C741.05 411.646 725.426 407.362 711.566 398.794C697.958 389.974 687.122 377.374 679.058 360.994C671.246 344.614 667.34 325.462 667.34 303.538C667.34 281.362 671.246 262.21 679.058 246.082C687.122 229.702 697.958 217.228 711.566 208.66C725.426 199.84 741.05 195.43 758.438 195.43ZM779.228 252.13C765.368 252.13 754.154 256.666 745.586 265.738C737.27 274.81 733.112 287.41 733.112 303.538C733.112 319.666 737.27 332.266 745.586 341.338C754.154 350.41 765.368 354.946 779.228 354.946C792.836 354.946 803.924 350.284 812.492 340.96C821.312 331.636 825.722 319.162 825.722 303.538C825.722 287.662 821.312 275.188 812.492 266.116C803.924 256.792 792.836 252.13 779.228 252.13ZM928.438 138.73C928.438 128.902 931.966 120.838 939.022 114.538C946.078 107.986 955.402 104.71 966.994 104.71C978.586 104.71 987.91 107.986 994.966 114.538C1002.02 120.838 1005.55 128.902 1005.55 138.73C1005.55 148.306 1002.02 156.37 994.966 162.922C987.91 169.222 978.586 172.372 966.994 172.372C955.402 172.372 946.078 169.222 939.022 162.922C931.966 156.37 928.438 148.306 928.438 138.73ZM999.124 198.076V409H934.486V198.076H999.124ZM1108.39 237.766C1116.45 224.914 1126.79 214.708 1139.39 207.148C1152.24 199.588 1166.1 195.808 1180.97 195.808V264.982H1162.44C1145.31 264.982 1131.95 268.636 1122.38 275.944C1113.05 283.252 1108.39 295.6 1108.39 312.988V409H1043.75V198.076H1108.39V237.766ZM1341.83 195.808C1366.02 195.808 1385.17 203.872 1399.29 220C1413.65 236.128 1420.83 258.304 1420.83 286.528V409H1356.19V294.088C1356.19 279.976 1352.41 269.014 1344.85 261.202C1337.55 253.138 1327.72 249.106 1315.37 249.106C1302.27 249.106 1291.81 253.264 1284 261.58C1276.44 269.896 1272.66 281.74 1272.66 297.112V409H1208.02V129.28H1272.66V236.632C1278.7 224.032 1287.65 214.078 1299.49 206.77C1311.59 199.462 1325.7 195.808 1341.83 195.808ZM1663.8 297.868C1663.8 303.16 1663.17 308.956 1661.91 315.256H1515.63C1516.38 331.132 1520.42 342.598 1527.72 349.654C1535.03 356.458 1544.36 359.86 1555.7 359.86C1565.27 359.86 1573.21 357.466 1579.51 352.678C1585.81 347.89 1589.97 341.716 1591.98 334.156H1660.4C1657.63 349.024 1651.58 362.38 1642.26 374.224C1632.93 385.816 1621.09 395.014 1606.73 401.818C1592.36 408.37 1576.36 411.646 1558.72 411.646C1538.06 411.646 1519.66 407.362 1503.53 398.794C1487.66 389.974 1475.18 377.374 1466.11 360.994C1457.04 344.614 1452.5 325.462 1452.5 303.538C1452.5 281.362 1456.91 262.21 1465.73 246.082C1474.8 229.702 1487.4 217.228 1503.53 208.66C1519.66 199.84 1538.06 195.43 1558.72 195.43C1579.64 195.43 1598.03 199.714 1613.91 208.282C1629.78 216.85 1642.01 228.946 1650.57 244.57C1659.39 259.942 1663.8 277.708 1663.8 297.868ZM1598.41 288.04C1598.66 274.18 1594.88 263.848 1587.07 257.044C1579.51 249.988 1570.06 246.46 1558.72 246.46C1546.88 246.46 1537.05 249.988 1529.24 257.044C1521.42 264.1 1517.01 274.432 1516.01 288.04H1598.41ZM1777.64 195.43C1793.76 195.43 1807.62 199.084 1819.22 206.392C1830.81 213.7 1839.38 223.654 1844.92 236.254V198.076H1909.18V409H1844.92V370.822C1839.38 383.422 1830.81 393.376 1819.22 400.684C1807.62 407.992 1793.76 411.646 1777.64 411.646C1760.25 411.646 1744.62 407.362 1730.76 398.794C1717.16 389.974 1706.32 377.374 1698.26 360.994C1690.44 344.614 1686.54 325.462 1686.54 303.538C1686.54 281.362 1690.44 262.21 1698.26 246.082C1706.32 229.702 1717.16 217.228 1730.76 208.66C1744.62 199.84 1760.25 195.43 1777.64 195.43ZM1798.43 252.13C1784.57 252.13 1773.35 256.666 1764.78 265.738C1756.47 274.81 1752.31 287.41 1752.31 303.538C1752.31 319.666 1756.47 332.266 1764.78 341.338C1773.35 350.41 1784.57 354.946 1798.43 354.946C1812.03 354.946 1823.12 350.284 1831.69 340.96C1840.51 331.636 1844.92 319.162 1844.92 303.538C1844.92 287.662 1840.51 275.188 1831.69 266.116C1823.12 256.792 1812.03 252.13 1798.43 252.13ZM2018.32 237.766C2026.38 224.914 2036.72 214.708 2049.32 207.148C2062.17 199.588 2076.03 195.808 2090.9 195.808V264.982H2072.37C2055.24 264.982 2041.88 268.636 2032.31 275.944C2022.98 283.252 2018.32 295.6 2018.32 312.988V409H1953.68V198.076H2018.32V237.766ZM2237.4 353.434V409H2208.29C2183.6 409 2164.32 402.952 2150.46 390.856C2136.85 378.508 2130.05 358.222 2130.05 329.998V252.508H2101.7V198.076H2130.05V146.29H2194.68V198.076H2237.02V252.508H2194.68V331.132C2194.68 339.448 2196.32 345.244 2199.6 348.52C2203.13 351.796 2208.92 353.434 2216.99 353.434H2237.4Z"
		fill="currentColor"
	/>
	<defs>
		<linearGradient
			id="paint0_linear_2227_994"
			x1="177.955"
			y1="343.467"
			x2="509.475"
			y2="25.3904"
			gradientUnits="userSpaceOnUse"
		>
			<stop offset="0.171875" stop-color="#FF00A8" />
			<stop offset="0.9375" stop-color="#FFE600" />
		</linearGradient>
		<linearGradient
			id="paint1_linear_2227_994"
			x1="312.256"
			y1="-43.7449"
			x2="352.77"
			y2="352.688"
			gradientUnits="userSpaceOnUse"
		>
			<stop stop-color="#620A3F" />
			<stop offset="1" stop-color="white" stop-opacity="0" />
		</linearGradient>
		<linearGradient
			id="paint2_linear_2227_994"
			x1="342.032"
			y1="-122.553"
			x2="348.974"
			y2="286.938"
			gradientUnits="userSpaceOnUse"
		>
			<stop stop-color="#620A3F" />
			<stop offset="1" stop-color="white" stop-opacity="0" />
		</linearGradient>
		<linearGradient
			id="paint3_linear_2227_994"
			x1="214.058"
			y1="-13.0972"
			x2="336.006"
			y2="290.047"
			gradientUnits="userSpaceOnUse"
		>
			<stop stop-color="#620A3F" />
			<stop offset="1" stop-color="white" stop-opacity="0" />
		</linearGradient>
		<linearGradient
			id="paint4_linear_2227_994"
			x1="349.273"
			y1="85.0368"
			x2="345.001"
			y2="392.372"
			gradientUnits="userSpaceOnUse"
		>
			<stop stop-color="#620A3F" />
			<stop offset="1" stop-color="white" stop-opacity="0" />
		</linearGradient>
		<linearGradient
			id="paint5_linear_2227_994"
			x1="167.983"
			y1="122.298"
			x2="439.179"
			y2="199.184"
			gradientUnits="userSpaceOnUse"
		>
			<stop stop-color="#620A3F" />
			<stop offset="1" stop-color="white" stop-opacity="0" />
		</linearGradient>
		<linearGradient
			id="paint6_linear_2227_994"
			x1="549.244"
			y1="72.2385"
			x2="405.701"
			y2="205.387"
			gradientUnits="userSpaceOnUse"
		>
			<stop stop-color="#620A3F" />
			<stop offset="1" stop-color="white" stop-opacity="0" />
		</linearGradient>
		<linearGradient
			id="paint7_linear_2227_994"
			x1="286.636"
			y1="95.4073"
			x2="415.964"
			y2="202.102"
			gradientUnits="userSpaceOnUse"
		>
			<stop stop-color="#620A3F" />
			<stop offset="1" stop-color="white" stop-opacity="0" />
		</linearGradient>
		<linearGradient
			id="paint8_linear_2227_994"
			x1="352.448"
			y1="262.383"
			x2="264.524"
			y2="404.258"
			gradientUnits="userSpaceOnUse"
		>
			<stop stop-color="#620A3F" />
			<stop offset="1" stop-color="white" stop-opacity="0" />
		</linearGradient>
		<linearGradient
			id="paint9_linear_2227_994"
			x1="505.769"
			y1="296.666"
			x2="269.654"
			y2="398.2"
			gradientUnits="userSpaceOnUse"
		>
			<stop stop-color="#620A3F" />
			<stop offset="1" stop-color="white" stop-opacity="0" />
		</linearGradient>
		<linearGradient
			id="paint10_linear_2227_994"
			x1="528.201"
			y1="399.398"
			x2="241.14"
			y2="396.52"
			gradientUnits="userSpaceOnUse"
		>
			<stop stop-color="#620A3F" />
			<stop offset="1" stop-color="white" stop-opacity="0" />
		</linearGradient>
		<linearGradient
			id="paint11_linear_2227_994"
			x1="307.792"
			y1="272.533"
			x2="219.101"
			y2="473.38"
			gradientUnits="userSpaceOnUse"
		>
			<stop stop-color="#620A3F" />
			<stop offset="1" stop-color="white" stop-opacity="0" />
		</linearGradient>
		<linearGradient
			id="paint12_linear_2227_994"
			x1="441.362"
			y1="276.158"
			x2="264.38"
			y2="447.89"
			gradientUnits="userSpaceOnUse"
		>
			<stop stop-color="#620A3F" />
			<stop offset="1" stop-color="white" stop-opacity="0" />
		</linearGradient>
		<linearGradient
			id="paint13_linear_2227_994"
			x1="355.081"
			y1="258.844"
			x2="310.544"
			y2="383.539"
			gradientUnits="userSpaceOnUse"
		>
			<stop stop-color="#620A3F" />
			<stop offset="1" stop-color="white" stop-opacity="0" />
		</linearGradient>
		<linearGradient
			id="paint14_linear_2227_994"
			x1="380.739"
			y1="226.512"
			x2="47.6634"
			y2="115.516"
			gradientUnits="userSpaceOnUse"
		>
			<stop stop-color="#620A3F" />
			<stop offset="1" stop-color="white" stop-opacity="0" />
		</linearGradient>
		<linearGradient
			id="paint15_linear_2227_994"
			x1="497.136"
			y1="124.215"
			x2="26.0016"
			y2="157.402"
			gradientUnits="userSpaceOnUse"
		>
			<stop stop-color="#620A3F" />
			<stop offset="1" stop-color="white" stop-opacity="0" />
		</linearGradient>
		<linearGradient
			id="paint16_linear_2227_994"
			x1="357.155"
			y1="260.918"
			x2="70.19"
			y2="118.555"
			gradientUnits="userSpaceOnUse"
		>
			<stop offset="0.187029" stop-color="#620A3F" />
			<stop offset="1" stop-color="white" stop-opacity="0" />
		</linearGradient>
		<linearGradient
			id="paint17_linear_2227_994"
			x1="323.433"
			y1="152.381"
			x2="75.1789"
			y2="138.507"
			gradientUnits="userSpaceOnUse"
		>
			<stop stop-color="#620A3F" />
			<stop offset="1" stop-color="white" stop-opacity="0" />
		</linearGradient>
		<linearGradient
			id="paint18_linear_2227_994"
			x1="344.944"
			y1="72.6543"
			x2="95.4122"
			y2="153.074"
			gradientUnits="userSpaceOnUse"
		>
			<stop stop-color="#620A3F" />
			<stop offset="1" stop-color="white" stop-opacity="0" />
		</linearGradient>
		<linearGradient
			id="paint19_linear_2227_994"
			x1="265.482"
			y1="141.867"
			x2="87.9368"
			y2="145.257"
			gradientUnits="userSpaceOnUse"
		>
			<stop stop-color="#620A3F" />
			<stop offset="1" stop-color="white" stop-opacity="0" />
		</linearGradient>
		<clipPath id="clip0_2227_994">
			<rect width="560" height="512.711" fill="white" />
		</clipPath>
	</defs>
</svg>
